import React, { useState } from "react";
import MenuTitle from "../../../Components/MenuTitlle/MenuTitle";
import QRCode from "react-qr-code";
import { useParams } from "react-router-dom";
import Style from "./QrCodeWithFactor.module.css";
import { createFactureQrCodeAPI } from "../../../Api/BarestSupplierServices";
import { errorToast } from "../../../Utils/Toast/Toast";
const QrCodeWithFactor = () => {
  const params = useParams();
  const[amountState,setAmountState]=useState("")
  const[descriptionState,setDescriptionState]=useState()
  const[loadingState,setloadingState]=useState(false)
  const[generate,setGenerate]=useState(false)
  const generateFactureHandler=()=>{
    if(!amountState){
      errorToast("مقدار خالی است")
      return
    }
    setloadingState(true)
    const info={
        user_id:"",
        order_id:"",
        user_type:"",
        amount:amountState,
        description:descriptionState
    }
    createFactureQrCodeAPI(info,(res)=>{
        if(res.status===1){
            setGenerate(true)
            setloadingState(false)
        }else{
            errorToast(res.message)
            setloadingState(false)
        }
    })
  }
  return (
    <div style={{ width: "100vw", height: "100vh" }}>
      <MenuTitle title={"بارکد با ثبت هزینه"} />
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection:'column',
          alignItems:'center',
          width: "100%",
          marginTop: "5rem",
        }}
      >
        {generate&&<QRCode
            size={256}
            style={{ height: "auto", maxWidth: "320", width: "100%" }}
            value={`https://barest.ir/f/?s=${params?.id}`}
            viewBox={`0 0 256 256`}
            fgColor="rgb(223, 0, 104)"
        />}
        <div className={Style.formHolder}>
          <div>
            <label htmlFor="">مقدار به تومان:</label>
            <input type="text" name="amount" onChange={(e)=>setAmountState(e.target.value)} value={amountState} />
          </div>
          <div>
            <label htmlFor="">توضیحات:</label>
            <textarea name="description" className={Style.TextAreaHolder} onChange={(e)=>setDescriptionState(e.target.value)} value={descriptionState}/>
          </div>
          <button disabled={loadingState} className={Style.ButtonHolder} onClick={generateFactureHandler}>
            {loadingState?"در حال ایجاد...":"ایجاد"}
          </button>
        </div>

        
      </div>
    </div>
  );
};

export default QrCodeWithFactor;
